module.exports = __webpack_public_path__ + "3c5a137336b4e0fa0c155afece11f57a.pdf";